import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FooterComponent } from '../footer-component/footer-component';
import { BillyticsPublicContainerComponent } from '../billytics-public-container-component/billytics-public-container-component';

@Component({
  selector: 'app-terms-and-conditions-component',
  imports: [MatToolbarModule, MatCardModule, BillyticsPublicContainerComponent],
  templateUrl: './terms-and-conditions-component.html',
  styleUrl: './terms-and-conditions-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsAndConditionsComponent {}
